import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Box } from "@mui/material";
import FullPageLayout from "../../components/FullPageLayout";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6, 8),
    backgroundColor: theme.palette.body,
    "& > div > div > div": {
      overflowX: "visible !important"
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 2)
    }
  },
  notSelected: {
    color: theme.palette.text.secondary
  },
  subtitle: {
    paddingTop: theme.spacing(4)
  }
}));

function TabContainer({ children }) {
  return <div>{children}</div>;
}

function Settings(props) {
  const { tabsInfo, tabsContent } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  function handleChangeIndex(index) {
    setValue(index);
  }

  return (
    <FullPageLayout title={t("settings.title")}>
      <Tabs
        data-qa="learning-center-settings-tabs"
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabsInfo.map((tab, index) => (
          <Tab
            key={index}
            classes={
              {
                //   textColorPrimary: classes.notSelected
              }
            }
            label={
              <Typography variant="h5">
                {t("settings." + tab.tabName)}
              </Typography>
            }
          />
        ))}
      </Tabs>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {tabsContent.map((tab, index) => (
          <TabContainer key={index} dir={theme.direction}>
            <Box p={1}>
              <Typography
                color="textSecondary"
                variant="subtitle1"
                className={classes.subtitle}
              >
                {t(tabsInfo[index].tabSubtitle)}
              </Typography>
              {tab}
            </Box>
          </TabContainer>
        ))}
      </SwipeableViews>
    </FullPageLayout>
  );
}

export default Settings;
